import { render, staticRenderFns } from "./CustomerGrade.vue?vue&type=template&id=7aa276a2&"
import script from "./CustomerGrade.vue?vue&type=script&lang=js&"
export * from "./CustomerGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports